import AppPage from "../AppPage";
import Logo from "../Logo";

import { globals, utilities } from "../../styles";

function StartPage(props: {
  handleLogin: () => void;
  handleSignUp: () => void;
}) {
  const { handleLogin, handleSignUp } = props;

  return (
    <AppPage className={`${globals["page"]} ${globals["start-page"]}`}>
      <Logo />
      <div
        className={`${utilities["flex-center"]} ${utilities["gap-20"]} ${utilities["margin-10-0"]}`}
      >
        <button
          id="Login"
          className={globals["button-wrapper"]}
          onClick={handleLogin}
        >
          <div className={globals["extra-lrg-btn"]}>Login</div>
        </button>
        <button
          id="Sign-up"
          className={globals["button-wrapper"]}
          onClick={handleSignUp}
        >
          <div className={globals["medium-btn"]}>Sign Up</div>
        </button>
      </div>
    </AppPage>
  );
}

export default StartPage;
